import { cn } from "@shortsworks/ui/lib/utils";
import AutoSizer from "react-virtualized-auto-sizer";
import { useNumber } from "../../hooks/useNumerFormatter";
import { useSecondsToTime } from "../../hooks/useFormatDateInterval";
import { useEffect, useState } from "react";
import { Area, AreaChart } from "recharts";

interface MetricCardProps {
  id: string;
  report?: any;
  title: string;
  format?: "number" | "currency" | "time" | "filesize";
  onClick?: (id: string) => void;
  selected?: boolean;
}

export const MetricCard = ({
  id,
  report,
  title,
  onClick,
  format = "number",
  selected,
}: MetricCardProps) => {
  const number = useNumber(format === "filesize" ? "en-US" : "ko-KR");
  const time = useSecondsToTime();
  const [summary, setSummary] = useState<number | null>(null);

  useEffect(() => {
    // sum report data
    const data = report?.data?.[id];
    if (data) {
      const sum = data.reduce(
        (acc: number, current: any) => acc + current.value,
        0,
      );
      setSummary(sum);
    }
  }, [report]);

  const handleClick = () => {
    onClick?.(id);
  };

  const getFormattedValue = (value: number) => {
    switch (format) {
      case "number":
        return number.format(value);
      case "time":
        return time(Math.round(value / 1000));
      case "filesize":
        return number.shortWithUnit(value, "GB");
      default:
        return value;
    }
  };

  return (
    <div
      className={cn(
        "group relative bg-white p-2 h-24 min-h-12 pointer shadow",
        "bg-white",
        selected && "bg-gray-50",
      )}
      // backgroundColor={ selected ? '#F8FAFC' : '#FFF'}
      // padding={'15px'}
      // height="100px"
      // minHeight="100px"
      // cursor={'pointer'}
      onClick={handleClick}
      // boxShadow="0 0 0 0.5px #E2E8F0"
    >
      <div
        className={cn(
          "absolute pointer-events-none bottom-1 left-0.5 right-0.5 top-0 z-0 group-hover:opacity-100 transition-opacity duration-300",
          selected ? "opacity-100" : "opacity-10",
        )}
        // bottom={'-0.25rem'}
        // left={'-0.25rem'}
        // right={'-0.25rem'}
      >
        <AutoSizer>
          {({ width, height }) => (
            <AreaChart
              width={width}
              height={height / 3}
              data={report?.data?.[id]}
              style={{ marginTop: (height / 3) * 2 }}
            >
              <Area
                dataKey="value"
                type="monotone"
                fill={`transparent`}
                fillOpacity={1}
                stroke={"#000"}
                strokeWidth={2}
                isAnimationActive={false}
              />
            </AreaChart>
          )}
        </AutoSizer>
      </div>
      <div className="text-base font-semibold" color="#9EA3AB">
        {title}
      </div>
      {report?.data && summary !== null && (
        <div
          // className={GeistSans.className}
          className="text-2xl font-semibold"
        >
          {getFormattedValue(summary)}
        </div>
      )}
    </div>
  );
};
